import { StyleSheet } from 'aphrodite';
import { titles, grayDark, borderColor, background } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		minHeight: '400px',
	},

	statusSection: {
		marginBottom: 16,
	},

	status: {
		display: 'flex',
		alignItems: 'center',
		padding: '12px 16px',
		borderRadius: 6,
		fontSize: 14,
		fontWeight: 500,
	},

	statusIndicator: {
		width: 8,
		height: 8,
		borderRadius: '50%',
		marginRight: 8,
	},

	statusText: {
		flex: 1,
		fontWeight: 500,
	},

	statusConnecting: {
		backgroundColor: '#fef3c7',
		border: '1px solid #f59e0b',
		color: '#92400e',
		'& $statusIndicator': {
			backgroundColor: '#f59e0b',
			animation: 'pulse 1.5s ease-in-out infinite',
		},
	},

	statusConnected: {
		backgroundColor: '#d1fae5',
		border: '1px solid #10b981',
		color: '#047857',
		'& $statusIndicator': {
			backgroundColor: '#10b981',
		},
	},

	statusDisconnected: {
		backgroundColor: '#fee2e2',
		border: '1px solid #ef4444',
		color: '#dc2626',
		'& $statusIndicator': {
			backgroundColor: '#ef4444',
		},
	},

	statusError: {
		backgroundColor: '#fee2e2',
		border: '1px solid #ef4444',
		color: '#dc2626',
		'& $statusIndicator': {
			backgroundColor: '#ef4444',
		},
	},

	errorMessage: {
		marginTop: 8,
		padding: '8px 12px',
		backgroundColor: '#fef2f2',
		border: '1px solid #fecaca',
		borderRadius: 4,
		color: '#dc2626',
		fontSize: 12,
	},

	instructionsSection: {
		marginBottom: 16,
	},

	instructions: {
		padding: '12px 16px',
		backgroundColor: '#eff6ff',
		border: '1px solid #3b82f6',
		borderRadius: 6,
		color: '#1e40af',
		fontSize: 14,
		margin: 0,
		lineHeight: '1.5',
	},

	transcriptSection: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 16,
	},

	transcriptHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: 12,
	},

	transcriptTitle: {
		fontSize: 16,
		fontWeight: 600,
		color: titles,
		margin: 0,
	},

	transcriptActions: {
		display: 'flex',
		gap: 8,
	},

	transcriptButton: {
		minWidth: 'auto',
		padding: '4px 12px',
	},

	transcriptContent: {
		flex: 1,
		maxHeight: 300,
		overflowY: 'auto',
		border: `1px solid ${borderColor}`,
		borderRadius: 6,
		backgroundColor: background,
		padding: 12,
	},

	transcriptPlaceholder: {
		color: grayDark,
		fontStyle: 'italic',
		textAlign: 'center',
		padding: '40px 20px',
		fontSize: 14,
	},

	transcriptEntry: {
		marginBottom: 16,
		padding: 12,
		borderRadius: 8,
		position: 'relative',
	},

	transcriptEntrySalesRep: {
		backgroundColor: '#f0f9ff',
		borderLeft: '4px solid #0ea5e9',
		marginLeft: 0,
		marginRight: 20,
	},

	transcriptEntryProspect: {
		backgroundColor: '#f9fafb',
		borderLeft: '4px solid #6b7280',
		marginLeft: 20,
		marginRight: 0,
	},

	transcriptSpeaker: {
		fontSize: 12,
		fontWeight: 600,
		color: titles,
		marginBottom: 4,
	},

	transcriptTimestamp: {
		fontSize: 10,
		color: grayDark,
		marginBottom: 6,
	},

	transcriptMessage: {
		fontSize: 14,
		color: titles,
		lineHeight: '1.4',
	},

	controlSection: {
		display: 'flex',
		justifyContent: 'center',
		paddingTop: 16,
		borderTop: `1px solid ${borderColor}`,
	},

	disconnectButton: {
		minWidth: 120,
	},
});
